module.exports = __webpack_public_path__ + "8d2e2a02b59fdcf7fe52f7590df2fed2.pdf";